import { TextField, Select, MenuItem, Typography, FormControl, InputLabel } from "@mui/material";
import { Controller } from "react-hook-form";

export const ControlledTextField = ({ name, control, label, type = "text", rules = {}, error, helperText }) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field }) => (
                <FormControl fullWidth margin="normal" variant="outlined" error={!!error}>
                    <TextField
                        {...field}
                        label={label}
                        type={type}
                        error={!!error}
                        helperText={helperText}
                        variant="outlined"
                    />
                </FormControl>
            )}
        />
    );
};

export const ControlledSelect = ({ name, control, label, rules = {}, error, helperText, options = [] }) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field }) => (
                <FormControl fullWidth margin="normal" variant="outlined" error={!!error}>
                    <InputLabel>{label}</InputLabel>
                    <Select
                        {...field}
                        value={field.value ?? ""}
                        label={label}
                    >
                        <MenuItem value="">
                            --Select {label}--
                        </MenuItem>
                        {options.map((option, index) => (
                            <MenuItem key={index} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                    {error && <Typography color="error">{helperText}</Typography>}
                </FormControl>
            )}
        />
    );
};